import { ref, get } from "firebase/database";

/**
 * Returns the application role for the given email by looking it up in
 * SuperAdmins and SalesManager lists. Null when the email is not allowed.
 */
export const findUserRole = async (db, email) => {
  if (!email) return null;

  const normalizedEmail = email.toLowerCase();

  const superAdminSnapshot = await get(ref(db, "SuperAdmins"));
  const superAdmins = superAdminSnapshot.val();
  if (superAdmins) {
    for (const key in superAdmins) {
      if (String(superAdmins[key]).toLowerCase() === normalizedEmail) {
        return "SuperAdmin";
      }
    }
  }

  const salesSnapshot = await get(ref(db, "SalesManager"));
  const salesManagers = salesSnapshot.val();
  if (salesManagers) {
    for (const key in salesManagers) {
      if (String(salesManagers[key]).toLowerCase() === normalizedEmail) {
        return "SalesManager";
      }
    }
  }

  return null;
};
